module.exports = __webpack_public_path__ + "img/DK22128612.cce46a1f.png";